import { countBy } from "lodash-es";
import logger from "../logger";
import type { FormVersion } from "../../state/formVersion";

const findDuplicates = (array: unknown[]) => {
  const occurrences = countBy(array);
  return Object.keys(occurrences).filter((key) => occurrences[key] > 1);
};

export const detectDuplicateFieldIds = (formVersion: FormVersion) => {
  const duplicates = findDuplicates(formVersion.fields.map((field) => field.uid));
  if (duplicates.length > 0) {
    logger.error("Form contains fields with duplicate ID's", { duplicates });
  }
};

export const detectDuplicateSubformIds = (formVersion: FormVersion) => {
  const duplicates = findDuplicates(formVersion.subforms.map((subform) => subform.uid));
  if (duplicates.length > 0) {
    logger.error("Form contains subforms with duplicate ID's", { duplicates });
  }
};
